<p-dialog header="Anular ausencia" [modal]="true" 
[draggable]="false" 
[resizable]="false"
styleClass="p-dialog-firma-custom"
[(visible)]="displayModalAnularAusencia" 
(onHide)="closeModal()" 
[style]="{width: '500px'}">
    <p>
        ¿Confirma anular la ausencia del estudio de <strong>{{ nombreEstudio }}</strong> del trabajador <strong>{{ nombreTrabajador }}</strong>?
    </p>
    <p>
        Al anular la ausencia, el estudio quedará en estado pendiente.
    </p>
    <p-footer>
        <p-button (click)="closeModal()">Cancelar</p-button>
        <p-button (click)="submitAnularAusencia()" id="clean-button">Anular ausencia</p-button>
    </p-footer>
</p-dialog> 